import api from './api';

export type HealthStatus = 'ok' | 'warn' | 'fail';

export interface HealthCheck {
  key: string;
  title: string;
  status: HealthStatus;
  summary: string;
  detail?: string[];
}

export interface HealthReport {
  checkedAt: string;
  status: HealthStatus;
  checks: HealthCheck[];
}

export interface HealthRun {
  id: number;
  checked_at: string;
  status: HealthStatus;
  alerted: boolean;
  checks: HealthCheck[];
}

export type AiFailureKind = 'credit' | 'auth' | 'rate_limit' | 'overloaded' | 'timeout' | 'other';

export interface AiComponentHealth {
  component: string;
  consecutiveFailures: number;
  lastKind: AiFailureKind | null;
  lastMessage: string | null;
  lastFailureAt: string | null;
  lastSuccessAt: string | null;
}

export interface AiStatus {
  degraded: AiComponentHealth[];
  creditExhausted: boolean;
  authFailed: boolean;
  summary: string;
}

export async function getSystemHealth(): Promise<HealthReport> {
  return (await api.get<HealthReport>('/system-health')).data;
}

/** AI availability only. Cheap enough to poll from the shell on every page. */
export async function getAiStatus(): Promise<AiStatus> {
  return (await api.get<AiStatus>('/system-health/ai')).data;
}

export async function getHealthHistory(limit = 30): Promise<HealthRun[]> {
  return (await api.get<HealthRun[]>('/system-health/history', { params: { limit } })).data;
}

/** Re-run the checks now. `force` re-sends the alert for an unchanged state. */
export async function runSystemHealth(force = false): Promise<HealthReport> {
  return (await api.post<HealthReport>('/system-health/run', { force }, { timeout: 180000 })).data;
}
